const BOT_UA_REGEX =
  /bot|crawler|spider|crawling|slurp|mediapartners-google|facebookexternalhit|whatsapp|telegrambot|slackbot|discordbot|linkedinbot|twitterbot|bingpreview|headless/i;

const CLIENT_SIDE_BOT_BLOCKED_ENDPOINTS = [
  "/hewebsites/v1/homepage/sub-inst-ajax",
  "/dom-search/v1/clearing/subjectAjax",
  "/dom-search/v1/clearing/institutionAjax",
  "/dom-search/v1/search/getScholarshipAjax",
  "/hewebsites/v1/guest/logs/clickstream",
  "/hewebsites/v1/logs/clickstream",

];

export const isBotUserAgent = (userAgent?: string | null): boolean => {
  if (!userAgent) return false;
  return BOT_UA_REGEX.test(userAgent);
};

export const shouldSkipClientAjaxForBot = (url: string): boolean => {
  if (typeof navigator === "undefined") return false;
  if (!isBotUserAgent(navigator.userAgent)) return false;
  return CLIENT_SIDE_BOT_BLOCKED_ENDPOINTS.some((endpoint) =>
    url.includes(endpoint),
  );
};

